import {CTABanner} from 'containers/Dashboard/CTABanners/CTABannersCarousel';
import MTBanner from 'assets/images/dashboard/banner/mt-banner.webp';
import {useMobile} from 'utils/hooks';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import {useRef} from 'react';
import {Button} from 'letrus-ui';
import styles from './writeTipsBanner.module.scss';

export const MATO_GROSSO_SCHOOL_NETWORK_ID = 115;
export const ESPIRITO_SANTO_SCHOOL_NETWORK_IDS = [
  3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 123,
];
export const LAST_HIGH_SCHOOL_GRADES = [12, 13];

function useWriteTipsBanner({priority}: {priority: number}): CTABanner {
  const {isMobile} = useMobile();
  const {userRole} = getUserData();
  const dialogRef = useRef<HTMLDialogElement>(null);

  const isMatoGrossoNetwork =
    userRole?.school_network_id === MATO_GROSSO_SCHOOL_NETWORK_ID;

  const isPrepCourse = LAST_HIGH_SCHOOL_GRADES.includes(userRole?.school_grade);

  return {
    priority,
    title: 'Dicas para descomplicar sua redação',
    theme: 'light',
    color: '#023ceb',
    icon: ['fad', 'envelope'],
    description:
      'Confira as dicas para mandar bem na redação e garantir uma boa nota!',
    action: {
      text: 'Ver dicas',
      onClick: () => dialogRef.current?.showModal(),
    },
    isVisible: () => isMatoGrossoNetwork && !isPrepCourse && !isMobile,
    modals: (
      <dialog ref={dialogRef} className={styles.tipsDialog}>
        <img src={MTBanner} alt="Dicas para descomplicar sua redação" />
        <Button variant="secondary" onClick={() => dialogRef.current?.close()}>
          Voltar
        </Button>
      </dialog>
    ),
  };
}

export default useWriteTipsBanner;
